export const LOCATION_SERVICE = "/location/v1";
export const LOCATION_SEARCHABLE_GET = `${LOCATION_SERVICE}/location/searchable/index.json`;
export const LOCATION_BY_KEY = `${LOCATION_SERVICE}/location`; // /{key}/detail.json
export const LOCATIONS_BY_IDS = `${LOCATION_SERVICE}/location/by_location_ids/index.json`;
export const SCHOOL_KEY_EXCEPTION = "298";
